import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import 'bootstrap/dist/css/bootstrap.min.css';

const API_URL = process.env.REACT_APP_API_URL
const JsonAktarPage = () => {
    const intl = useIntl();
    const [jsonData, setJsonData] = useState(null); // JSON verilerini saklamak için state
    const [files, setFiles] = useState<File[]>([]);
    const navigate = useNavigate();

    const onDrop = useCallback((acceptedFiles: File[]) => {
        setFiles(curr => [...curr, ...acceptedFiles]);
        const reader = new FileReader();
        reader.onload = async (e) => {
            let text = e.target?.result !== null && e.target !== null ? e.target.result.toString() : "";
            if (text.trim().endsWith(',')) {
                text = text.trim().slice(0, -1); // Son karakteri (virgül) sil
            }
            setJsonData(JSON.parse("[" + text + "]")); // JSON verisini state'e kaydet
            console.log(JSON.parse("[" + text + "]"))
        };
        reader.readAsText(acceptedFiles[0]);
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: {
            'application/json': ['.json'],
        },
        multiple: true
    });

    const handleUpload = async () => {
        if (files.length === 0) {
            alert('Lütfen json dosya(lar) seçin veya sürükleyip bırakın.');
            return;
        }

        const formData = new FormData();
        files.forEach(file => formData.append('files', file));

        try {
            const response = await axios.post(`${API_URL}/Custom/ImportTitleTopics`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            console.log(response.data);
            //alert('Dosya(lar) başarıyla yüklendi.');
            navigate('/create-request', { state: { jsonData } }); // JSON verisi ile yönlendirme
        } catch (error) {
            console.error('Dosya yüklenirken bir hata oluştu', error);
            alert('Dosya yüklenirken bir hata oluştu.');
        }
    };

    return (
        <div className='container mt-5'>
            <div {...getRootProps()} className='dropzone'>
                <input {...getInputProps()} />
                <p>Sürükleyip bırakarak dosya yükleyin veya tıklayarak seçin.</p>
            </div>
            {files.length > 0 && (
                <ul>
                    {files.map((file, index) => (
                        <li key={index}>{file.name}</li>
                    ))}
                </ul>
            )}
            <button className='btn btn-primary mt-3' onClick={handleUpload}>Yükle</button>
        </div>
    );
};

export { JsonAktarPage };
